import { LeagueResultModel } from "@/models/LeagueResultModels";
import { LeagueResultsRepo } from "@/repos/LeagueResultsRepo";

// src/services/LeagueResultService.ts
export class LeagueResultService {
    constructor(private leagueResultsRepo: LeagueResultsRepo) { }

    async get(id: string): Promise<LeagueResultModel | null> {
        return await this.leagueResultsRepo.getById(id);
    }

    async create(item: LeagueResultModel): Promise<void> {
        return await this.leagueResultsRepo.create(item, item.id);
    }

    async update(id: string, updates: Partial<LeagueResultModel>): Promise<void> {
        return await this.leagueResultsRepo.update(id, updates);
    }

    async delete(id: string): Promise<void> {
        return await this.leagueResultsRepo.delete(id);
    }
}